import React, {useEffect} from 'react';
import Breadcrumbs from "../../../../ui/Breadcrumbs";
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import QueryTable from "../../../../ui/QueryTable";
import useQuery from "../../../../ui/QueryTable/useQuery";
import {makeStyles, withStyles} from "@material-ui/core/styles";
import SimpleMenu from "../../../../ui/SimpleMenu";
import ProgramInfoDrawer from "../../../../ManageOOP/Resources/OpMod/MyOPMod/components/ProgramInfoDrawer";
import {createConstructorProgram} from "../../store/send";

const items = [
  {
    label: "Конструктор КиОП",
    link: "/work/app/constructor"
  },
  {
    label: "Конструктор образовательных программ",
    link: "/work/app/constructor/programs"
  },
];

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "row",
    "& #gridContainer": {
      height: "calc(100vh - 200px)"
    }
  },
});

const ProgramList = ({history, createConstructorProgram, createdProgram}) => {
  const [focusedProgram, setFocusedProgram] = React.useState(-1);
  const {root} = useStyles();
  const query = useQuery(10);

  useEffect(() => {
    query.load();
  }, []);

  const TableRowClick = (e) => {
    const focusedProgram = e ? e.key : -1;
    setFocusedProgram(focusedProgram);
  };

  useEffect(() => {
    if (createdProgram && createdProgram.success) {
      history.push(`/work/app/constructor/edit-program/${createdProgram.id}`);
    }
  }, [createdProgram]);

  const addProgramAction = [
    {
      label: "Создать программу",
      //disabled: true
      onClick: () => createConstructorProgram()
    }
  ];

  return (
    <div>
      <Breadcrumbs items={items} />
      <div className={root}>
        <QueryTable
          focusedId={focusedProgram}
          onRowClick={TableRowClick}
          primaryActions={<SimpleMenu type="add" actions={addProgramAction} />}
          {...query} />
        <ProgramInfoDrawer
          handleDrawerClose={() => TableRowClick(null)}
          linkConstructor
          programId={focusedProgram}
          open={focusedProgram !== -1}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  createdProgram: state.programConstruct.createdProgram
});

const mapDispatchToProps = dispatch => ({
  createConstructorProgram: () => dispatch(createConstructorProgram())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProgramList);
